/**
 * Waits for a specified number of milliseconds.
 * @param duration - Number of milliseconds to wait
 * @param signal - Optional AbortSignal that ends the wait early (resolves, never rejects)
 * @returns A promise that resolves after the specified time, or as soon as `signal` aborts
 */
export function delay(duration: number, signal?: AbortSignal): Promise<void> {
  if (!duration || signal?.aborted) {
    return Promise.resolve();
  }

  return new Promise((resolve) => {
    const done = () => {
      clearTimeout(timer);
      signal?.removeEventListener('abort', done);
      resolve();
    };
    const timer = setTimeout(done, duration);
    signal?.addEventListener('abort', done, { once: true });
  });
}
